import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["button", "input"]

  connect() {
    if (!this.hasButtonTarget) {
      return
    }

    const isEnabled = this.inputTarget.value === "true"
    this.buttonTarget.classList.toggle("active", isEnabled)

    // Get ai_service from form
    this.aiService = this.element.closest("form").dataset.aiService

    // Check if upgrade is required (check for truthy value, not just "true" string)
    this.upgradeRequired = this.buttonTarget.hasAttribute("disabled") ||
                           this.buttonTarget.dataset.upgradeRequired === "true" ||
                           this.buttonTarget.dataset.upgradeRequired === true

    // Find thinking input
    this.thinkingInput = document.querySelector('[data-thinking-toggle-target="input"]')
    if (this.thinkingInput) {
      this.thinkingInput.addEventListener("change", () => this.updateSearchButtonState())
    }
    // Always run initial check
    this.updateSearchButtonState()
  }

  toggle() {
    // Don't toggle if button is disabled or upgrade required
    if (this.buttonTarget.disabled || this.upgradeRequired) return

    const isEnabled = this.inputTarget.value === "true"
    this.inputTarget.value = (!isEnabled).toString()
    this.buttonTarget.classList.toggle("active", !isEnabled)
  }

  updateSearchButtonState() {
    if (!this.buttonTarget) return

    const thinking = this.thinkingInput ? this.thinkingInput.value === "true" : false
    const shouldDisable = this.upgradeRequired || (this.aiService === "openai" && thinking)

    // Disable or enable the button based on upgrade or OpenAI + thinking state
    this.buttonTarget.disabled = shouldDisable
    this.buttonTarget.style.cursor = shouldDisable ? "not-allowed" : "pointer"
    this.buttonTarget.style.opacity = shouldDisable ? "0.7" : "1"

    // Set appropriate tooltip message
    if (this.upgradeRequired) {
      this.buttonTarget.title = "Upgrade for web search"
    } else if (shouldDisable) {
      this.buttonTarget.title = "OpenAI has temporarily disabled web search with reasoning"
    } else {
      this.buttonTarget.title = "Enable Web Search"
    }

    $(this.buttonTarget).tooltip('dispose').tooltip()

    // If disabled — force search value to false and remove active class
    if (shouldDisable) {
      this.inputTarget.value = "false"
      this.buttonTarget.classList.remove("active")
    }
  }
}
